/** @format */

import "../src/css/App.css";
import "../src/css/ReportPage.css";
import "../src/css/Styles.css";
import "../src/css/colors_bt5.css";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.js";
import "bootstrap-icons/font/bootstrap-icons.css";

import React, { useEffect, useState } from "react";
import {
  useLocation,
  useNavigate,
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { useSelector, useDispatch } from "react-redux";
import ReportPage from "./components/menu/ReportPage";
import ReportPageMobileNew from "./components/mobile/ReportPageMobileNew";
import BottomMenuEn from "./components/menu/BottomMenuEn";
import BottomMenuTH from "./components/menu/BottomMenuTH";

import MaintenancePage from "./components/MaintenancePage.js";
import ModalAnnouncement from "./components/menu/ModalAnnouncement.js";

function AppContent() {
  const globalData = useSelector((state) => ({ ...state }));
  const location = useLocation(); // ใช้เพื่อตรวจสอบ URL ปัจจุบัน
  const navigate = useNavigate(); // ใช้สำหรับเปลี่ยนเส้นทาง
  const isMobile = useMediaQuery({ maxWidth: 767 });

  if (window.location.hostname !== "localhost") {
    if (window.location.protocol !== "https:") {
      window.location.replace(
        `https:${window.location.href.substring(
          window.location.protocol.length,
        )}`,
      );
    }
  }

  useEffect(() => {
    // ฟังก์ชันโหลด Google Translate
    const loadGoogleTranslate = () => {
      const script = document.createElement("script");
      script.src =
        "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      document.head.appendChild(script);
    };

    // ฟังก์ชันสำหรับ init การแปล
    const googleTranslateElementInit = () => {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: "th", // ภาษาเริ่มต้น
          includedLanguages: "en,th", // ภาษาให้แปล
          layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
          autoDisplay: false,
        },
        "google_translate_element",
      );

      setTimeout(() => {
        const selectElem = document.querySelector(".goog-te-combo");
        if (selectElem) {
          selectElem.value = "en"; // แปลเป็นภาษาอังกฤษ
          selectElem.dispatchEvent(new Event("change"));
        }
      }, 1000); // หน่วงเวลา 1 วินาที
    };

    // ตรวจสอบเส้นทาง URL และค่า toggle_language
    if (location.pathname === "/track") {
      // if (!globalData.language.toggle_language) {
      // โหลด Google Translate เฉพาะเมื่ออยู่ใน /track และ toggle_language เป็น false
      if (!window.googleTranslateElementInit) {
        window.googleTranslateElementInit = googleTranslateElementInit;
        loadGoogleTranslate();
      }
      // } else {
      //   // ถ้า toggle_language เป็น true ทำความสะอาดการแปล
      //   const googleTranslateElement = document.getElementById(
      //     "google_translate_element"
      //   );
      //   if (googleTranslateElement) {
      //     googleTranslateElement.innerHTML = ""; // ลบการแปลออก
      //   }
      // }
    }

    // ทำความสะอาดสคริปต์เมื่อออกจาก /track
    return () => {
      if (location.pathname === "/track") {
        // ไม่ทำความสะอาดเมื่อยังอยู่ใน /track
        return;
      }

      const script = document.querySelector(
        'script[src="//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"]',
      );
      if (script) {
        script.remove();
      }
      const googleTranslateElement = document.getElementById(
        "google_translate_element",
      );
      if (googleTranslateElement) {
        googleTranslateElement.innerHTML = ""; // ลบการแปลออก
      }
    };
  }, [location.pathname, globalData.language.toggle_language]);

  useEffect(() => {
    const currentPath = location.pathname;

    if (currentPath.startsWith("/report")) {
      navigate("/report", { replace: true });
    } else if (currentPath.startsWith("/track")) {
      navigate("/track", { replace: true });
    } else if (currentPath.startsWith("/about")) {
      navigate("/about", { replace: true });
    } else {
      navigate("/report", { replace: true });
    }
  }, [location.pathname]);

  return (
    <section>
      <ModalAnnouncement />
      <div id="google_translate_element"></div>
      <div className="overflow-hidden">
        {isMobile ? <ReportPageMobileNew /> : <ReportPage />}

        {isMobile &&
          (!globalData.language.toggle_language ? (
            <BottomMenuTH />
          ) : (
            <BottomMenuEn />
          ))}
      </div>
    </section>
  );
}

export default function App() {
  const [maintenance, setMaintenance] = useState(false);
  const [loading, setLoading] = useState(true); // รอผล API ก่อน render

  // ตรวจสอบ API ว่าเป็น maintenance หรือไม่

  useEffect(() => {
    const API_URL = "https://api.traffy.in.th/greeting-api/status";

    fetch(API_URL)
      .then((res) => {
        if (!res.ok) {
          console.error("greeting-api error:", res.status, res.statusText);
          throw new Error(`HTTP ${res.status}`);
        }
        return res.json();
      })
      .then((data) => {
        if (data.type === "error") {
          setMaintenance(true);
        } else {
          setMaintenance(false);
        }
      })
      .catch((err) => {
        console.error("Fetch greeting-api failed:", err);
        setMaintenance(true); // ถ้า fetch ล้มเหลวถือเป็น maintenance mode
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  // ไม่ render อะไรจนกว่าจะโหลด API เสร็จ
  if (loading) {
    return <div style={{ minHeight: "100vh" }}></div>;
  }
  return (
    <Router>
      <Routes>
        {maintenance ? (
          <>
            <Route path="/maintenance" element={<MaintenancePage />} />
            <Route path="*" element={<Navigate to="/maintenance" replace />} />
          </>
        ) : (
          <Route path="*" element={<AppContent />} />
        )}
      </Routes>
    </Router>
  );
}
